export default __webpack_public_path__ + "static/media/may-min.0e1e9ceb.jpg";